import { RootState } from "../../index";

export const selectApiList = (state: RootState) => state.apiLibrary.apiList;
export const selectApiPagination = (state: RootState) => state.apiLibrary.pagination;
export const selectApiLoading = (state: RootState) => state.apiLibrary.loading;
export const selectApiError = (state: RootState) => state.apiLibrary.error;

export const getContactPropertiesOptions = (state: RootState) => state.apiLibrary.contactOption;
export const getApiListOptions = (state: RootState) => state.apiLibrary.apiOptions;